// src/lib/auth.js
import axios from 'axios';

export const API_BASE =
  process.env.REACT_APP_API_BASE || 'https://teardrophydro.co.uk/garageFarm';

export const getToken = () => localStorage.getItem('accessToken') || '';
export const setToken  = (t) => localStorage.setItem('accessToken', t);
export const clearToken = () => localStorage.removeItem('accessToken');

export const getTokenExpiry = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return typeof payload.exp === 'number' ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
};

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      clearToken();
      if (window.location.pathname !== '/login') window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);
